<div class="ng-star-inserted">
    <div class="match-info-head text-white mb-0 bg-dark p-2 d-flex">
        <span class="font-weight-bold text-uppercase">
            {{ tournamentName }}
            @if (seasonName) {
            {{ seasonName }}
            } @if (subtournamentName) { - {{ subtournamentName }}
            }
        </span>
    </div>
    <div class="bg-white">
        <div id="collapse-drivers" class="collapse show">
            <div class="table-responsive">
                <table class="table table-sm stage-table">
                    <tbody>
                        @for (group of statsVal | keys; track $index) { @if (group.key !== 'init') {
                        <tr class="bg-light2">
                            <td class="small align-middle text-center" colspan="2">
                                {{ 'web.stats_' + group.key | translate }}
                            </td>
                        </tr>
                        } @for (stat of group.value | keys; track $index) {
                        <tr class="ng-star-inserted">
                            <td class="text-nowrap align-middle" width="80%">
                                {{ getParticipantStatKey(stat.key) | translate }}
                            </td>
                            <td class="text-nowrap align-middle text-right pr-2">
                                {{ stat.value.value | statsVal : stat.key }}
                            </td>
                        </tr>
                        } }
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
